import { render, staticRenderFns } from "./EditAccess.vue?vue&type=template&id=a9e1d140"
import script from "./EditAccess.vue?vue&type=script&lang=js"
export * from "./EditAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports